export default "__VITE_ASSET__rvw_8cbT__"